import { render, staticRenderFns } from "./OrCleanStorageModule.vue?vue&type=template&id=8fdeb9fa&scoped=true&"
import script from "./OrCleanStorageModule.vue?vue&type=script&lang=ts&"
export * from "./OrCleanStorageModule.vue?vue&type=script&lang=ts&"
import style0 from "./OrCleanStorageModule.vue?vue&type=style&index=0&id=8fdeb9fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdeb9fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
